export const decodeHtml = (inputText: string | undefined) => {
  let textArea = document.createElement('textarea');
  textArea.innerHTML = inputText || '';
  return textArea.value;
};
